import {
  FILTER_LOB_SUCCESS,
  FILTER_TAXID_SUCCESS,
  FILTER_TIME_PERIOD_SUCCESS,
  OVERVIEW_DATA_LOADING,
  OVERVIEW_DATA_REQUEST_SUCCESS,
  SETTLEMENT_COMMERCIAL_DATA_LOADING,
  SETTLEMENT_CURRENT_FLOW,
  SETTLEMENT_DATA_LOADING,
  SETTLEMENT_MEDICAID_DATA_LOADING,
  SETTLEMENT_MEDICARE_DATA_LOADING,
  SETTLEMENT_DETAILS_DATA_LOADING,
  SETTLEMENT_DETAILS_DATA_SUCCESS,
  SETTLEMENT_PAYMENT_DATA_LOADING,
  SETTLEMENT_PAYMENT_DATA_REQUEST,
  SETTLEMENT_PAYMENT_DATA_SUCCESS,
  SETTLEMENT_TINFILTER_DATA_LOADING,
  SETTLEMENT_TINFILTER_DATA_SUCCESS,
  SETTLEMENT_TREND_COMMERCIAL_SUCCESS,
  SETTLEMENT_TREND_DATA_LOADING,
  SETTLEMENT_TREND_DATA_REQUEST,
  SETTLEMENT_TREND_MEDICAID_SUCCESS,
  SETTLEMENT_TREND_MEDICARE_SUCCESS,
  SETTLEMENT_TREND_SUCCESS,
  SETTLEMENT_TREND_UNCATERGORIZED_SUCCESS,
  SETTLEMENT_UNCATEGORIZED_DATA_LOADING,
  SETTLEMENT_VOLUME_DATA_LOADING,
  SETTLEMENT_VOLUME_DATA_REQUEST,
  SETTLEMENT_VOLUME_DATA_SUCCESS,
  SETTLEMENT_GEOFILTER_DATA_SUCCESS,
  SETTLEMENT_EMPTY_DATA,
  SETTLEMENT_RESET_DATA,
  SETTLEMENT_GEOFILTER_REGION,
  SETTLEMENT_GEOFILTER_STATE,
  SETTLEMENT_GEOFILTER_MARKET,
  SETTLEMENT_GEOFILTER_DATA_REQUEST,
  GEO_STATE_HOME_VAL_CHECK,
  START_END_DATE_SUCCESS,
} from '../../../actions/actionTypes';

interface PaymentIntegrityState {
  opGraphData: any;
  isLoading: boolean;
  isLoadingGraphData: boolean;
  isLoadingSETTLEMENTData?: boolean;
  overViewCardData: any;
  quickFilterTinDataLoading: boolean;
  quickFilterTinData: any;
  filterTimePeriod: any;
  filterLob: string;
  filterLobMultiSelect: string[];
  filterTaxId: any;
  settlmentPaymentData?: any;
  currentFlow?: string;
  paymentDataLoading?: any;
  trendData?: any;
  settlementVolumeData?: any;
  volumeDataLoading?: any;
  trendMedicareData?: any;
  trendMedicaidData?: any;
  trendUncategorizedData?: any;
  trendCommercialData?: any;
  overViewCardLoading?: any;
  trendDataLoading?: any;
  medicareDataLoading?: any;
  medicaidDataLoading?: any;
  commercialDataLoading?: any;
  uncategorizedDataLoading?: any;
  settlementDetailsData?: any;
  settlementDetailsLoading?: boolean;
  geoFilterValues: any;
  emptyData?: any;
  geoRegion?: any;
  geoState?: any;
  geoMarket?: any;
  geoValChange?: any;
  startEnd?: { startDate?: string; endDate?: string } | null;
}

const initialState: PaymentIntegrityState = {
  opGraphData: {},
  overViewCardData: {},
  isLoading: false,
  isLoadingGraphData: false,
  isLoadingSETTLEMENTData: false,
  quickFilterTinDataLoading: true,
  quickFilterTinData: [],
  filterTimePeriod: "Last12Months",
  filterLob: "All",
  filterLobMultiSelect: [],
  filterTaxId: [],
  settlmentPaymentData: {},
  currentFlow: "",
  paymentDataLoading: true,
  volumeDataLoading: true,
  trendData: {},
  settlementVolumeData: {},
  trendMedicareData: {},
  trendMedicaidData: {},
  trendCommercialData: {},
  trendUncategorizedData: {},
  overViewCardLoading: true,
  trendDataLoading: true,
  medicareDataLoading: true,
  medicaidDataLoading: true,
  commercialDataLoading: true,
  uncategorizedDataLoading: true,
  settlementDetailsData: {},
  geoFilterValues: [],
  settlementDetailsLoading: true,
  emptyData: false,
  geoRegion: '',
  geoState: '',
  geoMarket: [],
  geoValChange: false,

};

const SettlementReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentIntegrityState => {
  switch (action.type) {
    case SETTLEMENT_DATA_LOADING:
      return {
        ...state,
        isLoadingSETTLEMENTData: action.payload,
      };

    case OVERVIEW_DATA_REQUEST_SUCCESS:
      return {
        ...state,
        overViewCardData: action.payload,
      };
    case SETTLEMENT_TINFILTER_DATA_SUCCESS:
      return {
        ...state,
        quickFilterTinData: action.payload,
      };
    case SETTLEMENT_TINFILTER_DATA_LOADING:
      return {
        ...state,
        quickFilterTinDataLoading: action.payload,
      };
    case FILTER_TIME_PERIOD_SUCCESS:
      return {
        ...state,
        filterTimePeriod: action.payload,
      };
    case FILTER_LOB_SUCCESS:
      return {
        ...state,
        filterLob: action.payload,
      };
    case 'FILTER_LOB_MULTI_SUCCESS':
      return {
        ...state,
        filterLobMultiSelect: action.payload,
      };
    case FILTER_TAXID_SUCCESS:
      return {
        ...state,
        filterTaxId: action.payload,
      };
    case SETTLEMENT_PAYMENT_DATA_LOADING:
      return {
        ...state,
        paymentDataLoading: action.payload,
      };
    case SETTLEMENT_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        settlmentPaymentData: action.payload,
      };

    case SETTLEMENT_TREND_DATA_REQUEST:
      return {
        ...state,
        trendData: action.payload,
      };
    case SETTLEMENT_VOLUME_DATA_SUCCESS:
      return {
        ...state,
        settlementVolumeData: action.payload,
      };
    case SETTLEMENT_VOLUME_DATA_LOADING:
      return {
        ...state,
        volumeDataLoading: action.payload,
      };
    case SETTLEMENT_TREND_SUCCESS:
      return {
        ...state,
        trendData: action.payload,
      };
    case SETTLEMENT_TREND_MEDICAID_SUCCESS:
      return {
        ...state,
        trendMedicaidData: action.payload,
      };
    case SETTLEMENT_TREND_MEDICARE_SUCCESS:
      return {
        ...state,
        trendMedicareData: action.payload,
      };
    case SETTLEMENT_TREND_COMMERCIAL_SUCCESS:
      return {
        ...state,
        trendCommercialData: action.payload,
      };
    case SETTLEMENT_TREND_UNCATERGORIZED_SUCCESS:
      return {
        ...state,
        trendUncategorizedData: action.payload,
      };
    case OVERVIEW_DATA_LOADING:
      return {
        ...state,
        overViewCardLoading: action.payload,
      };
    case SETTLEMENT_TREND_DATA_LOADING:
      return {
        ...state,
        trendDataLoading: action.payload,
      };
    case SETTLEMENT_MEDICARE_DATA_LOADING:
      return {
        ...state,
        medicareDataLoading: action.payload,
      };
     case SETTLEMENT_MEDICAID_DATA_LOADING:
      return {
        ...state,
        medicaidDataLoading: action.payload,
      };
    case SETTLEMENT_COMMERCIAL_DATA_LOADING:
      return {
        ...state,
        commercialDataLoading: action.payload,
      };
     case SETTLEMENT_UNCATEGORIZED_DATA_LOADING:
      return {
        ...state,
        uncategorizedDataLoading: action.payload,
      };
    case SETTLEMENT_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        settlementDetailsData: action.payload,
      };
    case SETTLEMENT_DETAILS_DATA_LOADING:
      return {
        ...state,
        settlementDetailsLoading: action.payload,
      };
    case SETTLEMENT_EMPTY_DATA:
      return {
        ...state,
        emptyData: action.payload,
      };


      case SETTLEMENT_RESET_DATA:
      return {
         ...state,
          paymentDataLoading: false,
          volumeDataLoading: false,
          settlementDetailsLoading: false,
          overViewCardLoading: false,
          trendDataLoading: false,
          settlmentPaymentData: {},
          settlementVolumeData: {},
          trendData: {},
          trendMedicareData: {},
          trendMedicaidData: {},
      };
    case SETTLEMENT_CURRENT_FLOW:
      return {
        ...state,
        currentFlow: action.payload,
      };
    case SETTLEMENT_GEOFILTER_DATA_SUCCESS:
    return {
      ...state,
      geoFilterValues: action.payload,
    };
     case SETTLEMENT_GEOFILTER_REGION:
    return {
      ...state,
      geoRegion: action.payload,
    };
     case SETTLEMENT_GEOFILTER_STATE:
    return {
      ...state,
      geoState: action.payload,
    };
     case SETTLEMENT_GEOFILTER_MARKET:
    return {
      ...state,
      geoMarket: action.payload,
    };

    case GEO_STATE_HOME_VAL_CHECK:
      return {
        ...state,
        geoValChange: action.payload,
      };
    case START_END_DATE_SUCCESS:{
      return {
        ...state,
        startEnd : action.payload
      }
    }

    default:
      return state;
  }
};

export default SettlementReducer;
